export const STATUSES = ["Approved", "Rejected", "Revision Pending"];
export function statusClass(status) {
  return status.toLowerCase().replaceAll(" ", "-");
}
export default function StatusBadge({ status }) {
  return (
    <span className={`status-badge ${statusClass(status)}`}>
      <span />
      {status}
    </span>
  );
}
